<template>
	<div v-loading="element_loading" element-loading-text="拼命加载中......" element-loading-spinner="el-icon-loading"
		element-loading-background="rgba(0, 0, 0, 0.8)" class="inline-oil">
		<h3>已经逾期但是还未结清</h3>
		<!-- 主界面内容显示 start -->
		<pre-table ref="file_table" @tab-event="refresh_data" :api_url="load_url" :pre_post="load_json"
			:pre_post_upd="''">
			<!-- 设定标题  -->
			<template slot="tab_title">
				<tr class="tab_header_new" :class="[isTwo=='1'?TwoNone:'']">
					<td>ID</td>
					<td v-for="(t,index) in parm_th" :key="index">{{t.name}}</td>
				</tr>
			</template>
			<template slot="tab_tr" slot-scope="user">
				<tr :id="'m_'+user.item[0].val" :class="[isTwo=='1'?TwoNone:'']" @click="sel_row(user.item,'all')">
					<!-- <a href="#"> -->
					<td v-for="(d,index) in user.item" :key="index" v-on:mousemove="show_detaildata($event, d.val, '1')"
						v-on:mouseout="noshow_detaildata">
						<div v-if="d.key=='img_url'">
							<el-image style="width: 20px; height: 20px" :src="check_url(d.val)"
								:preview-src-list="[check_url(d.val)]">
							</el-image>
						</div>
						<div v-else-if="d.key=='f_web_url'">
							<a :href="d.val" target="_blank">外链</a>
						</div>
						<div v-else>{{d.val}}</div>
					</td>
					<!-- </a> -->
				</tr>
			</template>
			<!-- 构建新增模板 -->
			<template slot="tab_addorupdate">

			</template>
		</pre-table>
		<!-- 主界面内容显示 end -->

		<!-- 明细数据提示 -->
		<div id="pre_detail_data" style="display:none;">
			<p v-for="(item, index) in detail_data" :key="index">
				{{ item.name }}={{ item.amount }}
			</p>
		</div>
		<div id="pre_msg_data" style="display:none;"></div>
	</div>
</template>

<script>
	import api from '@/utils/type.js'

	import {
		Sel_page_and_length
	} from '@/utils/loadhttpdata.js';

	import {
		GetShort,
		DeleteSpecialWord,
		BackSpecial,
		ChangeSpecial,
		GetRandom
	} from "@/utils/localstore.js";

	export default {
		name: "paysheet",
		components: {
			"pre-table": () => import("../auto/auto_view_table.vue")
		},
		data() {
			return {
				element_loading: false,

				load_url: '',
				load_json: '',
				upd_json: '',
				nowpage: '1',
				page_length: 20, //add 2022-01-25 默认分页长度

				sel_action: '',
				upd_action: '',

				parm_sel: [], //查询结构
				parm: [], //参数结构
				parm_th: [], //标题

				// 备注
				detail_data: '',
				// 定义默认样式
				isTwo: '0',
				isTwoDetail: '0',
				TwoNone: 'last-two-none',
				DTwoNone: "dlast-two-none",


			};
		},
		created: function() {
			// console.log('油卡 组件 创建');
			// this.loaddata();
		},
		mounted: function() {
			// console.log('油卡 组件 mounted');
			this.loaddata();
		},
		// activated: function() {
		//   console.log('油卡 组件激活时调用 激活');

		// },
		methods: {
			check_url: function(url) {
				let t = BackSpecial(url);
				// console.log(t);
				return t;
			},
			loaddata: function() {
				this.sel_action = 'exp_cw_paysheet_d_total_overdue';
				this.upd_action = '';

				this.parm_sel = [];
				this.parm = [];
				this.parm_th = [{
						"name": "序号"
					},
					{
						"name": "业务单号"
					},
					{
						"name": "销售订单"
					},
					{
						"name": "经办人"
					},
					// {
					// 	"name": "状态"
					// },
					// {
					// 	"name": "开始日期"
					// },
					// {
					// 	"name": "结束日期"
					// },
					// {
					// 	"name": "全款金额"
					// },
					// {
					// 	"name": "首付金额"
					// },
					// {
					// 	"name": "几号还款"
					// },
					// {
					// 	"name": "分期期数"
					// },
					// {
					// 	"name": "年利息"
					// },
					// {
					// 	"name": "滞纳金比例"
					// },
					{
						"name": "提前预警天数"
					},
					{
						"name": "车牌"
					},
					{
						"name": "付款方"
					},
					{
						"name": "付款方电话"
					},
					{
						"name": "还款顺序"
					},
					{
						"name": "还款日期"
					},
					{
						"name": "应还本金"
					},
					{
						"name": "应还利息"
					},
					{
						"name": "计息天数"
					},
					{
						"name": "应交滞纳金"
					},
					{
						"name": "逾期天数"
					},
					{
						"name": "应收总额"
					},
					{
						"name": "支付利息"
					},
					{
						"name": "支付本金"
					},
					{
						"name": "支付滞纳金"
					},
					{
						"name": "实收总额"
					},
{
						"name": "未收总额"
					},
					{
						"name": "备注"
					},
					{
						"name": "修改人"
					},
					{
						"name": "更新时间"
					}
				];

				this.load_db_data();
			},
			load_db_data: function() {
				// //console.log('全条件查询====');
				// //console.log(this.parm_sel);
				for (let i = 0; i < this.parm_sel.length; i++) {
					let t = 0;
					t = i + 1 + '';
					switch (t) {
						case '1':
							this.kw1 = this.parm_sel[i].val;
							break;
						case '2':
							this.kw2 = this.parm_sel[i].val;
							break;
						case '3':
							this.kw3 = this.parm_sel[i].val;
							break;
						case '4':
							this.kw4 = this.parm_sel[i].val;
							break;
						case '5':
							this.kw5 = this.parm_sel[i].val;
							break;
						case '6':
							this.kw6 = this.parm_sel[i].val;
							break;
						case '7':
							this.kw7 = this.parm_sel[i].val;
							break;
						case '8':
							this.kw8 = this.parm_sel[i].val;
							break;
						case '9':
							this.kw9 = this.parm_sel[i].val;
							break;
						case '10':
							this.kw10 = this.parm_sel[i].val;
							break;
					}
				}

				let that = this;
				let r = (Math.random() + '').substring(0, 8);
				setTimeout(function() {
					that.load_url = api.http_method;
					that.load_json = Sel_page_and_length(that.sel_action, that.nowpage, that.page_length, that
						.kw1,
						that
						.kw2, that.kw3, that.kw4, that.kw5, that.kw6, that.kw7, that.kw8, that.kw9, that
						.kw10, r);
				}, 200);
			},
			refresh_data: function(type, page, pagelength, backdata) {
				//console.log('查询刷新=' + type + ' page=' + page + ' pagelength=' + pagelength);


				if (type == 'PAGE_LENGTH_CHANGE' || type == 'UPDATE_OK') {
					this.page_length = pagelength;
					this.nowpage = page;
					this.load_db_data();
				}

			},
			sel_row: function(item, type) {
				// //console.log(item);

				// 切换背景色
				if (type != 'edit') {
					this.$refs.file_table.setCurrentRowJson('m_', item[0].val);
				}
			},
			show_detaildata: function(that, item, type) {
				var x = 0,
					y = 0,
					temp_css = '';
				// //console.log('明细数据显示坐标 ' + x + ' ' + y);
				// //console.log(that);
				x = that.pageX + 10;
				y = that.pageY;

				var screenWidth = $(window).width();
				var screenHeight = $(window).height(); //当前浏览器窗口的 宽高
				// var scrolltop = $(document).scrollTop();//获取当前窗口距离页面顶部高度

				// //console.log('页面宽度=' + screenWidth + '页面高度=' + screenHeight);
				// //console.log('明细数据显示坐标 ' + x + ' ' + y);

				// if ((x + 140) > screenWidth) {
				// 	x = x - 160;
				// }
				x = x - 180;
				y = y - 40;

				temp_css = "display: block;position: absolute;top:" + y + "px;left:" + x +
					"px;background-color: #537bff;border: 1px solid black;padding-left: 20px;padding-right: 20px;border-radius: 5px;z-index: 99999;";
				if (type == "0" && item.detail_data.length > 0) {
					this.detail_data = item.detail_data;

					document.getElementById("pre_detail_data").style.cssText = temp_css;
				}
				if (type == "1" && item != '') {
					temp_css += "max-width: 600px;word-break: break-all;padding-top: 5px;padding-bottom: 5px;";

					let temp_innerHtml = '';
					temp_innerHtml = BackSpecial(item);
					// temp_innerHtml = temp_innerHtml.replace(/\r\n/g, "<br/>").replace(/\n/g, "<br/>")

					document.getElementById("pre_msg_data").innerText = temp_innerHtml;
					document.getElementById("pre_msg_data").style.cssText = temp_css;
				}
			},
			noshow_detaildata: function() {
				// //console.log('不显示明细');
				document.getElementById("pre_detail_data").style.display = 'none';
				document.getElementById("pre_msg_data").style.display = 'none';
			},

		}


	}
</script>

<style scoped="scoped">

</style>